export default "__VITE_PUBLIC_ASSET__b382e049__"